import { Component, OnInit,Output,Input,EventEmitter, OnDestroy } from '@angular/core';
import { PatientsService } from '../patients.service';
import { LoginService } from '../login.service';
import { AppointmentsService } from '../appointments.service';
@Component({
    selector: 'app-patient-info',
    templateUrl: './patient-info.component.html',
    styleUrls: ['./patient-info.component.scss'],
    standalone: false
})
export class PatientInfoComponent implements OnInit {
  @Output() pageChange = new EventEmitter<string>();
  editPat=false;
  appointments=[];
  preAppointments=[];
  showPrevious=false
  showAppointment=false
  selectedEventInfo=null

  constructor(public patientService:PatientsService,public ls:LoginService, public appointmentService: AppointmentsService) { }

   ngOnInit() {
    this.getPatAppointments()
  }

  
  setPage(page:string){
    this.pageChange.emit(page);
  }

  async updateArrival(appointmentId,value){
  if(!appointmentId) return
  try{
    await this.appointmentService.arrived(appointmentId,this.patientService.currentPatient.PID,value)
    this.getPatAppointments()
  }catch(error){
    console.error(error);
  }
  }

  async getPatAppointments(){
    // const appointments=await this.patientService.getAppointments(this.patientService.currentPatient.PID);
    // this.appointments=appointments['current']
    // this.preAppointments=appointments['previous']
  }

  
  isToday(date: Date): boolean {
    const today = new Date();
    const appointmentDate = new Date(date);

    return appointmentDate.getDate() === today.getDate() &&
           appointmentDate.getMonth() === today.getMonth() &&
           appointmentDate.getFullYear() === today.getFullYear();
  }

closeAppointment(){
  this.showAppointment=false;
  this.getPatAppointments()
}

editAppointment(appointment){
  this.selectedEventInfo =appointment
  this.appointmentService.setAppointment(this.selectedEventInfo)
  this.showAppointment = true
}


}
